import { FetchResult } from "@apollo/client";

export default async function withRetries<T>(handler: () => Promise<FetchResult<T>>): Promise<T | undefined | null> {
    let lastErrors: readonly Error[] = [];
    for (let attempt = 0; attempt < 4; attempt += 1) {
        // eslint-disable-next-line no-await-in-loop
        const { data, errors } = await handler();
        if (!errors) {
            return data;
        }
        lastErrors = errors;
    }
    throw lastErrors[0];
}
